export const VRIO_SCORE_MIN = 0;
export const VRIO_SCORE_MAX = 4;

export const clampVrioScore = (value: number | string | null | undefined): number => {
  const n = typeof value === 'number' ? value : Number.parseInt(String(value ?? ''), 10);
  if (!Number.isFinite(n)) return VRIO_SCORE_MIN;
  return Math.min(VRIO_SCORE_MAX, Math.max(VRIO_SCORE_MIN, Math.trunc(n)));
};

export type VrioNguyenTacScores = {
  V: number;
  R: number;
  I: number;
  O: number;
  chon: boolean;
};

export const parseVrioNguyenTac = (nguyenTac?: string | null): VrioNguyenTacScores | null => {
  if (!nguyenTac) return null;
  try {
    const parsed = JSON.parse(nguyenTac);
    if (Array.isArray(parsed) && parsed.length >= 4) {
      return {
        V: clampVrioScore(parsed[0]),
        R: clampVrioScore(parsed[1]),
        I: clampVrioScore(parsed[2]),
        O: clampVrioScore(parsed[3]),
        chon: parsed.length >= 5 ? !!parsed[4] : false,
      };
    }
  } catch {
    // not a VRIO array
  }
  return null;
};

export const buildVrioNguyenTac = (V: number, R: number, I: number, O: number, chon?: boolean): string => {
  const scores: number[] = [clampVrioScore(V), clampVrioScore(R), clampVrioScore(I), clampVrioScore(O)];
  if (chon) {
    scores.push(1);
  }
  return JSON.stringify(scores);
};
